/**
 * This ENUM expresses the REST endpoints for Plat Builder.
 * String substitution using String.replace() should be used to insert variables where applicable.
 */

const API_METHODS = {
  GET_USER: 'user',
  GET_USERS: '/portals/self/users',
  SEARCH: 'search',
  GET_ITEM: 'content/items/{itemId}',
  GET_ITEM_DATA: 'content/items/{itemId}/data',
  UPDATE_ITEM: 'content/users/{username}/items/{itemId}/update',
  ADD_ITEM: 'content/users/{username}/addItem'
};

export default API_METHODS;



// WEBPACK FOOTER //
// ./src/services/enum.js